import React, { useEffect, useState } from 'react';
import { KRNWTRForm } from './components/KRNWTRForm';
import { IdValidation } from './components/IdValidation';
import { ThankYouPage } from './components/ThankYouPage';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { useLocation } from 'react-router-dom';
export function App() {
  const [formState, setFormState] = useState('id-validation'); // 'id-validation', 'form', 'thank-you'
  const [customerId, setCustomerId] = useState('');
  const location = useLocation();
  // Check if ID exists in URL query params
  useEffect(() => {
    // Only check query parameter (?id=)
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    if (id && (id.length === 15 || id.length === 18)) {
      setCustomerId(id);
      setFormState('form');
    }
  }, [location.search]);
  const handleIdSubmit = (id: string) => {
    setCustomerId(id);
    setFormState('form');
  };
  const handleFormSubmit = () => {
    setFormState('thank-you');
  };
  return <div className="min-h-screen bg-gradient-to-br from-[#C8FAF1] to-[#FFD6E3] p-3 sm:p-4 md:p-6 flex flex-col" data-id="element-0">
      <div className="max-w-3xl mx-auto w-full flex-grow" data-id="element-1">
        <Header data-id="element-2" />
        {formState === 'id-validation' && <IdValidation onSubmit={handleIdSubmit} data-id="element-3" />}
        {formState === 'form' && <KRNWTRForm customerId={customerId} onSubmit={handleFormSubmit} data-id="element-4" />}
        {formState === 'thank-you' && <ThankYouPage data-id="element-5" />}
      </div>
      <Footer data-id="element-6" />
    </div>;
}